/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationsEventCreateRequest
 */
export interface MatchOperationsEventCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventCreateRequest
     */
    clientEventId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventCreateRequest
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsEventCreateRequest
     */
    period?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MatchOperationsEventCreateRequest
     */
    elapsedMs?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventCreateRequest
     */
    teamId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventCreateRequest
     */
    teamSide?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventCreateRequest
     */
    playerId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof MatchOperationsEventCreateRequest
     */
    clientTimestamp?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventCreateRequest
     */
    note?: string | null;
}

/**
 * Check if a given object implements the MatchOperationsEventCreateRequest interface.
 */
export function instanceOfMatchOperationsEventCreateRequest(value: object): value is MatchOperationsEventCreateRequest {
    return true;
}

export function MatchOperationsEventCreateRequestFromJSON(json: any): MatchOperationsEventCreateRequest {
    return MatchOperationsEventCreateRequestFromJSONTyped(json, false);
}

export function MatchOperationsEventCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsEventCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientEventId': json['clientEventId'] == null ? undefined : json['clientEventId'],
        'type': json['type'] == null ? undefined : json['type'],
        'period': json['period'] == null ? undefined : json['period'],
        'elapsedMs': json['elapsedMs'] == null ? undefined : json['elapsedMs'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamSide': json['teamSide'] == null ? undefined : json['teamSide'],
        'playerId': json['playerId'] == null ? undefined : json['playerId'],
        'clientTimestamp': json['clientTimestamp'] == null ? undefined : (new Date(json['clientTimestamp'])),
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function MatchOperationsEventCreateRequestToJSON(json: any): MatchOperationsEventCreateRequest {
    return MatchOperationsEventCreateRequestToJSONTyped(json, false);
}

export function MatchOperationsEventCreateRequestToJSONTyped(value?: MatchOperationsEventCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientEventId': value['clientEventId'],
        'type': value['type'],
        'period': value['period'],
        'elapsedMs': value['elapsedMs'],
        'teamId': value['teamId'],
        'teamSide': value['teamSide'],
        'playerId': value['playerId'],
        'clientTimestamp': value['clientTimestamp'] == null ? value['clientTimestamp'] : value['clientTimestamp'].toISOString(),
        'note': value['note'],
    };
}

